import styled from 'styled-components';
import { Flex } from '../../../components/blocks';
import { AppTheme } from '../../../styles/theme';

type Props = {
  border?: keyof AppTheme['borderColors'];
  radii?: keyof AppTheme['radii'];
  bgColor?: keyof AppTheme['backgroundColors'];
  shadow?: keyof AppTheme['boxShadow'];
};

export const Card = styled(Flex)<Props>`
  background: ${({ theme, bgColor }) =>
    bgColor && theme.backgroundColors[bgColor]};
  box-shadow: ${({ theme, shadow }) => shadow && theme.boxShadow[shadow]};
  border: 1px solid
    ${({ theme, border }) =>
      border ? theme.borderColors[border] : theme.borderColors.default};
  border-radius: ${({ theme, radii }) => radii && theme.radii[radii]};
`;
